import BaseAPI from "./BaseAPI";
import { dispatchRoute } from "../routes";

export default class DispatchAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, dispatchRoute, "dispatch");
    }

    async Create(data, idempotencyKey = null) {
        const options = idempotencyKey
            ? { headers: { "Idempotency-Key": idempotencyKey } }
            : {};
        const result = await this._request("post", this._url(), data, options);
        this._emit("create", result.id);
        return result;
    }

    async Void(id) {
        const result = await this._request("post", this._url(`/${id}/void`));
        this._emit("void", id);
        return result;
    }

    async MarkArchived(id) {
        const result = await this._request("put", this._url(`/${id}/archive`));
        this._emit("mark-archived", id);
        return result;
    }

    async UnmarkArchived(id) {
        const result = await this._request("delete", this._url(`/${id}/archive`));
        this._emit("unmark-archived", id);
        return result;
    }
}
